var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConsole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 504.2 292.6",
    style: {
      enableBackground: "new 0 0 504.2 292.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M421.5,122.8h-6.5c-0.9,0-1.7,0.8-1.7,1.7s0.8,1.7,1.7,1.7h6.5c0.9,0,1.7-0.8,1.7-1.7S422.5,122.8,421.5,122.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M470.7,185.6h-3.2c-0.9,0-1.7,0.8-1.7,1.7s0.8,1.7,1.7,1.7h3.2c0.9,0,1.7-0.8,1.7-1.7S471.6,185.6,470.7,185.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M491.9,180.7h-18.4v-54.5c0-5.4-4.4-9.8-9.8-9.8h-34.3V19.3c0-9.6-7.8-17.4-17.4-17.4H152.7 c-9.6,0-17.4,7.8-17.4,17.4v127.9H27.6c-4.9,0-8.9,4-8.9,8.9v114.2c0,1.8,0.5,3.4,1.4,4.8H7c-2.5,0-4.5,2-4.5,4.5 c0,7.7,6.2,11,14.5,11h183.3c8.3,0,14.5-3.4,14.5-11c0-2.5-2-4.5-4.5-4.5h-13.1c0.9-1.4,1.4-3,1.4-4.8v-54.4h53.8v24.7h-19 c-5.4,0-9.8,4.4-9.8,9.8s4.4,3.5,9.8,3.5h98.4c5.4,0,9.8,1.9,9.8-3.5s-4.4-9.8-9.8-9.8h-19v-24.7h50.5v51c0,5.4,4.4,9.8,9.8,9.8 h63.5v4.1c0,5.5,4.4,9.9,9.9,9.9h45.6c5.5,0,9.9-4.4,9.9-9.9v-90.2C501.8,185.1,497.3,180.7,491.9,180.7L491.9,180.7z M436.4,256.1 v17.1h-63.5c-3.5,0-6.4-2.9-6.4-6.4V126.2c0-3.5,2.9-6.4,6.4-6.4h90.9c3.5,0,6.4,2.9,6.4,6.4v54.5h-23.8c-5.5,0-9.9,4.4-9.9,9.9 L436.4,256.1L436.4,256.1z M194.3,215.9v54.4c0,2.6-2.1,4.8-4.8,4.8H27.6c-2.6,0-4.8-2.1-4.8-4.8V156.1c0-2.6,2.1-4.8,4.8-4.8 h161.9c2.6,0,4.8,2.1,4.8,4.8L194.3,215.9L194.3,215.9z M198.5,203.6v-47.4c0-4.9-4-8.9-8.9-8.9h-41.8v-127c0-2.2,1.5-4.1,3.3-4.1 h263.3c1.8,0,3.3,1.8,3.3,4.1v96.2h-44.8c-5.4,0-9.8,4.4-9.8,9.8v77.4L198.5,203.6L198.5,203.6z M500.1,280.8 c0,4.5-3.7,8.2-8.2,8.2h-45.6c-4.5,0-8.2-3.7-8.2-8.2v-90.2c0-1.1,0.2-2.2,0.6-3.2c0.2-0.5,0.5-1,0.8-1.4c0.3-0.4,0.6-0.8,1-1.2 c0.2-0.2,0.4-0.4,0.6-0.5c0.9-0.7,1.9-1.2,2.9-1.5c0.5-0.1,0.9-0.2,1.4-0.3c0.3,0,0.5,0,0.8,0h45.6c4.5,0,8.2,3.7,8.2,8.2V280.8 L500.1,280.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsole);
export default __webpack_public_path__ + "static/media/console.7b759c507fbe5ff07acb79f0c2b4f09f.svg";
export { ForwardRef as ReactComponent };